import React from "react";
import { Row, Col, Spin } from "antd";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as propertyActions from "../../../../actionCreators/Property";
import TableSearch from "../../../../Components/TableSearch";

function Register({ properties, getProperties, user, ...props }) {
  const [isDistrictAdmin] = React.useState(user?.currentUser?.data?.user_roles.findIndex((e) => e.role_id === 5) >=
	0 ? true : false);
	const [adminDistrictId] = React.useState(user?.currentUser?.data?.district?.id);

  
  React.useEffect(() => {
    let filterBody = {
      eto: null,
      ti: null,
      circles: [],
      zones: [],
      status: [],
    }
    if(isDistrictAdmin && adminDistrictId) {
      filterBody = JSON.stringify({
        ...filterBody,
        districts: [adminDistrictId],
      })
    } else {
      filterBody = JSON.stringify({
        ...filterBody,
        districts: [],
      })
    }
    getProperties({
      page: 0,
      pageSize: 10,
      type: "existing",
      filterBody
    });
  }, []);

  React.useEffect(() => {
    if (properties?.data) {
      props?.handlePropertyCount(properties?.pagination?.count);
    }
  }, [properties?.data]);

  const filterPropertiesData = (x) => {
    const filterBody = x.filterBody;
    if(isDistrictAdmin && adminDistrictId) {
      filterBody.districts = [adminDistrictId]
    }
    getProperties({
      page: x?.page - 1,
      pageSize: x?.size,
      type: "existing",
      filterBody: JSON.stringify(x?.filterBody),
      search_by_name: x.searchText,
    })
  }

  return (
    <Row>
      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
        <TableSearch
          onRowClick={(x) => {}}
          tableName={"registeredProperties"}
          data={{ data: properties?.data, pagination: properties?.pagination }}
          sendRequestParams={(x) => filterPropertiesData(x)}
          loading={properties?.loading}
          isDistrictAdmin={isDistrictAdmin}
          {...props}
        />
      </Col>
    </Row>
  );
}

const mapStateToProps = ({
  user: user,
  property: { properties, registeredProperties },
}) => ({ properties, registeredProperties, user });

const mapDispatchToProps = (dispatch) => ({
  getProperties: bindActionCreators(propertyActions.getProperties, dispatch),
});

Register.propTypes = {
  properties: PropTypes.object.isRequired,
  getProperties: PropTypes.func.isRequired,
  getCurrentProperty: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Register);
